import React, { Component } from "react";
import styled from "styled-components";

class PageFooter extends Component {
  render() {
    return (
      <Container>
        <Info>Arthur Perfect Job</Info>
      </Container>
    );
  }
}

const Container = styled.div`
  width: 100%;
  height: 50px;
  background: #000000;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  display: block;
`;

const Info = styled.p`
  margin: 0;
  padding: 15px 10px 15px 10px;
  color: #555555;
  text-align: center;
  display: block;
`;

export default PageFooter;



// WEBPACK FOOTER //
// ./src/components/layout/PageFooter.js